import { useNetworkMetadata } from "Flocknote/apiHooks";

import useFileMutation from "Utilities/Hooks/useFileMutation";

import { setNetworkPhoto } from "./fetch";
import { navBarKeys } from "./keys";

const useSetNetworkPhoto = () => {
  const [{ everyoneGroupID }] = useNetworkMetadata();
  return useFileMutation({
    mutationKey: navBarKeys.setNetworkPhoto,
    mutationFn: setNetworkPhoto,
    additionFormData: { itemID: everyoneGroupID },
  });
};

export { useSetNetworkPhoto };
